export const tinyEditorKey = process.env.VUE_APP_TINY_MCE_KEY || "";
